<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card" style="min-width: 800px;">

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h5>Labels</h5>
          </div>
          <div class="col col-lg-2">
            <h5>None</h5>
          </div>
          <div class="col col-lg-2">
            <h5>Viewer</h5>
          </div>
          <div class="col col-lg-2">
            <h5>Editor</h5>
          </div>
          <div class="col col-lg-2">
            <h5>Admin</h5>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h5 class="portionHeading">Customers</h5>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customers" 
                name="customers" 
                value="None"
                v-model="customers" 
              />
              <label class="pt-1" for="customers">None</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customers" 
                name="customers" 
                value="Viewer"
                v-model="customers" 
              />
              <label class="pt-1" for="customers">Viewer</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customers" 
                name="customers" 
                value="Editor"
                v-model="customers" 
              />
              <label class="pt-1" for="customers">Editor</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customers" 
                name="customers" 
                value="Admin"
                v-model="customers" 
              />
              <label class="pt-1" for="customers">Admin</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Can Browse?</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerCanBrowse" 
                name="canBrowse" 
                value="No"
                v-model="customerCanBrowse" 
              />
              <label class="pt-1" for="customerCanBrowse">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerCanBrowse" 
                name="canBrowse" 
                value="Yes"
                v-model="customerCanBrowse" 
              />
              <label class="pt-1" for="customerCanBrowse">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">New</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerNew" 
                name="new" 
                value="No"
                v-model="customerNew" 
              />
              <label class="pt-1" for="customerNew">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerNew" 
                name="new" 
                value="Needs Approval"
                v-model="customerNew" 
              />
              <label class="pt-1" for="customerNew">Needs Approval</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerNew" 
                name="new" 
                value="Approved"
                v-model="customerNew" 
              />
              <label class="pt-1" for="customerNew">Approved</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Edit</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerEdit" 
                name="edit" 
                value="No"
                v-model="customerEdit" 
              />
              <label class="pt-1" for="customerEdit">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerEdit" 
                name="edit" 
                value="Partial"
                v-model="customerEdit" 
              />
              <label class="pt-1" for="customerEdit">Partial</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerEdit" 
                name="edit" 
                value="Full"
                v-model="customerEdit" 
              />
              <label class="pt-1" for="customerEdit">Full</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Delete</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerDelete" 
                name="delete" 
                value="No"
                v-model="customerDelete" 
              />
              <label class="pt-1" for="customerDelete">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="customerDelete" 
                name="delete" 
                value="Yes"
                v-model="customerDelete" 
              />
              <label class="pt-1" for="customerDelete">Yes</label>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h5 class="portionHeading">Contacts</h5>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contacts" 
                name="contacts" 
                value="None"
                v-model="contacts" 
              />
              <label class="pt-1" for="contacts">None</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contacts" 
                name="contacts" 
                value="Viewer"
                v-model="contacts" 
              />
              <label class="pt-1" for="contacts">Viewer</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contacts" 
                name="contacts" 
                value="Editor"
                v-model="contacts" 
              />
              <label class="pt-1" for="contacts">Editor</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contacts" 
                name="contacts" 
                value="Admin"
                v-model="contacts" 
              />
              <label class="pt-1" for="contacts">Admin</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Can Browse?</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contactCanBrowse" 
                name="canBrowse" 
                value="No"
                v-model="contactCanBrowse" 
              />
              <label class="pt-1" for="contactCanBrowse">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contactCanBrowse" 
                name="canBrowse" 
                value="Yes"
                v-model="contactCanBrowse" 
              />
              <label class="pt-1" for="contactCanBrowse">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">New</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contactNew" 
                name="new" 
                value="No"
                v-model="contactNew" 
              />
              <label class="pt-1" for="contactNew">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contactNew" 
                name="new" 
                value="Yes"
                v-model="contactNew" 
              />
              <label class="pt-1" for="contactNew">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Edit</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contactEdit" 
                name="edit" 
                value="No"
                v-model="contactEdit" 
              />
              <label class="pt-1" for="contactEdit">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contactEdit" 
                name="edit" 
                value="Yes"
                v-model="contactEdit" 
              />
              <label class="pt-1" for="contactEdit">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Delete</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contactDelete" 
                name="delete" 
                value="No"
                v-model="contactDelete" 
              />
              <label class="pt-1" for="contactDelete">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="contactDelete" 
                name="delete" 
                value="Yes"
                v-model="contactDelete" 
              />
              <label class="pt-1" for="contactDelete">Yes</label>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h5 class="portionHeading">Activities</h5>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activities" 
                name="activities" 
                value="None"
                v-model="activities" 
              />
              <label class="pt-1" for="activities">None</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activities" 
                name="activities" 
                value="Viewer"
                v-model="activities" 
              />
              <label class="pt-1" for="activities">Viewer</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activities" 
                name="activities" 
                value="Editor"
                v-model="activities" 
              />
              <label class="pt-1" for="activities">Editor</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activities" 
                name="activities" 
                value="Admin"
                v-model="activities" 
              />
              <label class="pt-1" for="activities">Admin</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Can Browse?</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activityCanBrowse" 
                name="canBrowse" 
                value="No"
                v-model="activityCanBrowse" 
              />
              <label class="pt-1" for="activityCanBrowse">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activityCanBrowse" 
                name="canBrowse" 
                value="Yes"
                v-model="activityCanBrowse" 
              />
              <label class="pt-1" for="activityCanBrowse">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">New</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activityNew" 
                name="new" 
                value="No"
                v-model="activityNew" 
              />
              <label class="pt-1" for="activityNew">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activityNew" 
                name="new" 
                value="Yes"
                v-model="activityNew" 
              />
              <label class="pt-1" for="activityNew">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Edit</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activityEdit" 
                name="edit" 
                value="No"
                v-model="activityEdit" 
              />
              <label class="pt-1" for="activityEdit">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activityEdit" 
                name="edit" 
                value="Yes"
                v-model="activityEdit" 
              />
              <label class="pt-1" for="activityEdit">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Delete</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activityDelete" 
                name="delete" 
                value="No"
                v-model="activityDelete" 
              />
              <label class="pt-1" for="activityDelete">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="activityDelete" 
                name="delete" 
                value="Yes"
                v-model="activityDelete" 
              />
              <label class="pt-1" for="activityDelete">Yes</label>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h5 class="portionHeading">Quotations</h5>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotations" 
                name="quotations" 
                value="None"
                v-model="quotations" 
              />
              <label class="pt-1" for="quotations">None</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotations" 
                name="quotations" 
                value="Viewer"
                v-model="quotations" 
              />
              <label class="pt-1" for="quotations">Viewer</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotations" 
                name="quotations" 
                value="Editor"
                v-model="quotations" 
              />
              <label class="pt-1" for="quotations">Editor</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotations" 
                name="quotations" 
                value="Admin"
                v-model="quotations" 
              />
              <label class="pt-1" for="quotations">Admin</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Can Browse?</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotationCanBrowse" 
                name="canBrowse" 
                value="No"
                v-model="quotationCanBrowse" 
              />
              <label class="pt-1" for="quotationCanBrowse">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotationCanBrowse" 
                name="canBrowse" 
                value="Yes"
                v-model="quotationCanBrowse" 
              />
              <label class="pt-1" for="quotationCanBrowse">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">New</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotationNew" 
                name="new" 
                value="No"
                v-model="quotationNew" 
              />
              <label class="pt-1" for="quotationNew">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotationNew" 
                name="new" 
                value="Yes"
                v-model="quotationNew" 
              />
              <label class="pt-1" for="quotationNew">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Edit</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotationEdit" 
                name="edit" 
                value="No"
                v-model="quotationEdit" 
              />
              <label class="pt-1" for="quotationEdit">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotationEdit" 
                name="edit" 
                value="Yes"
                v-model="quotationEdit" 
              />
              <label class="pt-1" for="quotationEdit">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Delete</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotationDelete" 
                name="delete" 
                value="No"
                v-model="quotationDelete" 
              />
              <label class="pt-1" for="quotationDelete">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="quotationDelete" 
                name="delete" 
                value="Yes"
                v-model="quotationDelete" 
              />
              <label class="pt-1" for="quotationDelete">Yes</label>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h5 class="portionHeading">Settings</h5>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="settings" 
                name="settings" 
                value="None"
                v-model="settings" 
              />
              <label class="pt-1" for="settings">None</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="settings" 
                name="settings" 
                value="Viewer"
                v-model="settings" 
              />
              <label class="pt-1" for="settings">Viewer</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="settings" 
                name="settings" 
                value="Editor"
                v-model="settings" 
              />
              <label class="pt-1" for="settings">Editor</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="settings" 
                name="settings" 
                value="Admin"
                v-model="settings" 
              />
              <label class="pt-1" for="settings">Admin</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Branches</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="settingBranches" 
                name="settingBranches" 
                value="None"
                v-model="settingBranches" 
              />
              <label class="pt-1" for="settingBranches">None</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="settingBranches" 
                name="settingBranches" 
                value="View"
                v-model="settingBranches" 
              />
              <label class="pt-1" for="settingBranches">View</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="settingBranches" 
                name="settingBranches" 
                value="Edit"
                v-model="settingBranches" 
              />
              <label class="pt-1" for="settingBranches">Edit</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="settingBranches" 
                name="settingBranches" 
                value="New"
                v-model="settingBranches" 
              />
              <label class="pt-1" for="settingBranches">New</label>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h5 class="portionHeading">Reports</h5>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="reports" 
                name="reports" 
                value="None"
                v-model="reports" 
              />
              <label class="pt-1" for="reports">None</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="reports" 
                name="reports" 
                value="Viewer"
                v-model="reports" 
              />
              <label class="pt-1" for="reports">Viewer</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="reports" 
                name="reports" 
                value="Editor"
                v-model="reports" 
              />
              <label class="pt-1" for="reports">Editor</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="reports" 
                name="reports" 
                value="Admin"
                v-model="reports" 
              />
              <label class="pt-1" for="reports">Admin</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Won Quotations</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="wonQuotations" 
                name="wonQuotations" 
                value="No"
                v-model="wonQuotations" 
              />
              <label class="pt-1" for="wonQuotations">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="wonQuotations" 
                name="wonQuotations" 
                value="Yes"
                v-model="wonQuotations" 
              />
              <label class="pt-1" for="wonQuotations">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Lost Quotations</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="lostQuotations" 
                name="lostQuotations" 
                value="No"
                v-model="lostQuotations" 
              />
              <label class="pt-1" for="lostQuotations">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="lostQuotations" 
                name="lostQuotations" 
                value="Yes"
                v-model="lostQuotations" 
              />
              <label class="pt-1" for="lostQuotations">Yes</label>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h5 class="portionHeading">Functions</h5>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="functions" 
                name="functions" 
                value="None"
                v-model="functions" 
              />
              <label class="pt-1" for="functions">None</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="functions" 
                name="functions" 
                value="Viewer"
                v-model="functions" 
              />
              <label class="pt-1" for="functions">Viewer</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="functions" 
                name="functions" 
                value="Editor"
                v-model="functions" 
              />
              <label class="pt-1" for="functions">Editor</label>
            </div>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="functions" 
                name="functions" 
                value="Admin"
                v-model="functions" 
              />
              <label class="pt-1" for="functions">Admin</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Can set enquiry to cancelled?</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="canSetEnquiryToCancelled" 
                name="canSetEnquiryToCancelled" 
                value="No"
                v-model="canSetEnquiryToCancelled" 
              />
              <label class="pt-1" for="canSetEnquiryToCancelled">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="canSetEnquiryToCancelled" 
                name="canSetEnquiryToCancelled" 
                value="Yes"
                v-model="canSetEnquiryToCancelled" 
              />
              <label class="pt-1" for="canSetEnquiryToCancelled">Yes</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4 col-sm-2">
            <h6 class="pt-1">Can set quotation to cancelled?</h6>
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="canSetQuotationToCancelled" 
                name="canSetQuotationToCancelled" 
                value="No"
                v-model="canSetQuotationToCancelled" 
              />
              <label class="pt-1" for="canSetQuotationToCancelled">No</label>
            </div>
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
          </div>
          <div class="col col-lg-2">
            <div class="p-field-radiobutton">
              <RadioButton 
                id="canSetQuotationToCancelled" 
                name="canSetQuotationToCancelled" 
                value="Yes"
                v-model="canSetQuotationToCancelled" 
              />
              <label class="pt-1" for="canSetQuotationToCancelled">Yes</label>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/service/UserService";

export default {
  created() {
    this.userService
      .getRoles()
      .then(data => {
        
      })
      .catch(error => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting user roles",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "roles"'
        })
      })
  },
  data: () => ({
    userService: new UserService(),

    customers: 'None',
    customerCanBrowse: 'No',
    customerNew: 'No',
    customerEdit: 'No',
    customerDelete: 'No',

    contacts: 'None',
    contactCanBrowse: 'No',
    contactNew: 'No',
    contactEdit: 'No',
    contactDelete: 'No',

    activities: 'None',
    activityCanBrowse: 'No',
    activityNew: 'No',
    activityEdit: 'No',
    activityDelete: 'No',

    quotations: 'None',
    quotationCanBrowse: 'No',
    quotationNew: 'No',
    quotationEdit: 'No',
    quotationDelete: 'No',

    settings: 'None',
    settingBranches: 'None',

    reports: 'None',
    wonQuotations: 'No',
    lostQuotations: 'No',

    functions: 'None',
    canSetEnquiryToCancelled: 'No',
    canSetQuotationToCancelled: 'No',
  }),
  watch: {
    customers(val) {
      if (val === 'None') {
        this.customerCanBrowse = 'No'
        this.customerNew = 'No'
        this.customerEdit = 'No'
        this.customerDelete = 'No'
      } else if (val === 'Viewer') {
        this.customerCanBrowse = 'No'
        this.customerNew = 'No'
        this.customerEdit = 'No'
        this.customerDelete = 'No'
      } else if (val === 'Editor') {
        this.customerCanBrowse = 'No'
        this.customerNew = 'Needs Approval'
        this.customerEdit = 'Partial'
        this.customerDelete = 'No'
      } else if (val === 'Admin') {
        this.customerCanBrowse = 'Yes'
        this.customerNew = 'Approved'
        this.customerEdit = 'Full'
        this.customerDelete = 'Yes'
      }
    },
    customerCanBrowse(val) {
      this.checkCustomers()
    },
    customerNew(val) {
      this.checkCustomers()
    },
    customerEdit(val) {
      this.checkCustomers()
    },
    customerDelete(val) {
      this.checkCustomers()
    },

    contacts(val) {
      if (val === 'None') {
        this.contactCanBrowse = 'No'
        this.contactNew = 'No'
        this.contactEdit = 'No'
        this.contactDelete = 'No'
      } else if (val === 'Viewer') {
        this.contactCanBrowse = 'No'
        this.contactNew = 'No'
        this.contactEdit = 'No'
        this.contactDelete = 'No'
      } else if (val === 'Editor') {
        this.contactCanBrowse = 'No'
        this.contactNew = 'No'
        this.contactEdit = 'No'
        this.contactDelete = 'No'
      } else if (val === 'Admin') {
        this.contactCanBrowse = 'Yes'
        this.contactNew = 'Yes'
        this.contactEdit = 'Yes'
        this.contactDelete = 'Yes'
      }
    },
    contactCanBrowse(val) {
      this.checkContacts()
    },
    contactNew(val) {
      this.checkContacts()
    },
    contactEdit(val) {
      this.checkContacts()
    },
    contactDelete(val) {
      this.checkContacts()
    },

    activities(val) {
      if (val === 'None') {
        this.activityCanBrowse = 'No'
        this.activityNew = 'No'
        this.activityEdit = 'No'
        this.activityDelete = 'No'
      } else if (val === 'Viewer') {
        this.activityCanBrowse = 'No'
        this.activityNew = 'No'
        this.activityEdit = 'No'
        this.activityDelete = 'No'
      } else if (val === 'Editor') {
        this.activityCanBrowse = 'No'
        this.activityNew = 'No'
        this.activityEdit = 'No'
        this.activityDelete = 'No'
      } else if (val === 'Admin') {
        this.activityCanBrowse = 'Yes'
        this.activityNew = 'Yes'
        this.activityEdit = 'Yes'
        this.activityDelete = 'Yes'
      }
    },
    activityCanBrowse(val) {
      this.checkActivities()
    },
    activityNew(val) {
      this.checkActivities()
    },
    activityEdit(val) {
      this.checkActivities()
    },
    activityDelete(val) {
      this.checkActivities()
    },

    quotations(val) {
      if (val === 'None') {
        this.quotationCanBrowse = 'No'
        this.quotationNew = 'No'
        this.quotationEdit = 'No'
        this.quotationDelete = 'No'
      } else if (val === 'Viewer') {
        this.quotationCanBrowse = 'No'
        this.quotationNew = 'No'
        this.quotationEdit = 'No'
        this.quotationDelete = 'No'
      } else if (val === 'Editor') {
        this.quotationCanBrowse = 'No'
        this.quotationNew = 'No'
        this.quotationEdit = 'No'
        this.quotationDelete = 'No'
      } else if (val === 'Admin') {
        this.quotationCanBrowse = 'Yes'
        this.quotationNew = 'Yes'
        this.quotationEdit = 'Yes'
        this.quotationDelete = 'Yes'
      }
    },
    quotationCanBrowse(val) {
      this.checkQuotations()
    },
    quotationNew(val) {
      this.checkQuotations()
    },
    quotationEdit(val) {
      this.checkQuotations()
    },
    quotationDelete(val) {
      this.checkQuotations()
    },
    
    settings(val) {
      if (val === 'None') {
        this.settingBranches = 'None'
      } else if (val === 'Viewer') {
        this.settingBranches = 'View'
      } else if (val === 'Editor') {
        this.settingBranches = 'Edit'
      } else if (val === 'Admin') {
        this.settingBranches = 'New'
      }
    },
    settingBranches(val) {
      this.checkSettings()
    },

    reports(val) {
      if (val === 'None') {
        this.wonQuotations = 'No'
        this.lostQuotations = 'No'
      } else if (val === 'Viewer') {
        this.wonQuotations = 'No'
        this.lostQuotations = 'No'
      } else if (val === 'Editor') {
        this.wonQuotations = 'No'
        this.lostQuotations = 'No'
      } else if (val === 'Admin') {
        this.wonQuotations = 'Yes'
        this.lostQuotations = 'Yes'
      }
    },
    wonQuotations(val) {
      this.checkReports()
    },
    lostQuotations(val) {
      this.checkReports()
    },

    functions(val) {
      if (val === 'None') {
        this.canSetEnquiryToCancelled = 'No'
        this.canSetQuotationToCancelled = 'No'
      } else if (val === 'Viewer') {
        this.canSetEnquiryToCancelled = 'No'
        this.canSetQuotationToCancelled = 'No'
      } else if (val === 'Editor') {
        this.canSetEnquiryToCancelled = 'No'
        this.canSetQuotationToCancelled = 'No'
      } else if (val === 'Admin') {
        this.canSetEnquiryToCancelled = 'Yes'
        this.canSetQuotationToCancelled = 'Yes'
      }
    },
    canSetEnquiryToCancelled(val) {
      this.checkFunctions()
    },
    canSetQuotationToCancelled(val) {
      this.checkFunctions()
    },
  },
  methods: {
    checkCustomers() {
      if (
        !(
          (
            this.customerCanBrowse === 'Yes' &&
            this.customerNew === 'Approved' &&
            this.customerEdit === 'Full' &&
            this.customerDelete === 'Yes'
          ) ||
          (
            this.customerCanBrowse === 'No' &&
            this.customerNew === 'Needs Approval' &&
            this.customerEdit === 'Partial' &&
            this.customerDelete === 'No'
          ) ||
          (
            this.customerCanBrowse === 'No' &&
            this.customerNew === 'No' &&
            this.customerEdit === 'No' &&
            this.customerDelete === 'No'
          )
        )
      ) {
        this.customers = ''
      }

      if (
        this.customerCanBrowse === 'Yes' &&
        this.customerNew === 'Approved' &&
        this.customerEdit === 'Full' &&
        this.customerDelete === 'Yes'
      ) {
        this.customers = 'Admin'
      } else if (
        this.customerCanBrowse === 'No' &&
        this.customerNew === 'Needs Approval' &&
        this.customerEdit === 'Partial' &&
        this.customerDelete === 'No'
      ) {
        this.customers = 'Editor'
      } else if (
        this.customerCanBrowse === 'No' &&
        this.customerNew === 'No' &&
        this.customerEdit === 'No' &&
        this.customerDelete === 'No'
      ) {
        this.customers = 'None'
      }
    },
    checkContacts() {
      if (
        !(
          (
            this.contactCanBrowse === 'Yes' &&
            this.contactNew === 'Yes' &&
            this.contactEdit === 'Yes' &&
            this.contactDelete === 'Yes'
          ) ||
          (
            this.contactCanBrowse === 'No' &&
            this.contactNew === 'No' &&
            this.contactEdit === 'No' &&
            this.contactDelete === 'No'
          )
        )
      ) {
        this.contacts = ''
      }

      if (
        this.contactCanBrowse === 'Yes' &&
        this.contactNew === 'Yes' &&
        this.contactEdit === 'Yes' &&
        this.contactDelete === 'Yes'
      ) {
        this.contacts = 'Admin'
      } else if (
        this.contactCanBrowse === 'No' &&
        this.contactNew === 'No' &&
        this.contactEdit === 'No' &&
        this.contactDelete === 'No'
      ) {
        this.contacts = 'None'
      }
    },
    checkActivities() {
      if (
        !(
          (
            this.activityCanBrowse === 'Yes' &&
            this.activityNew === 'Yes' &&
            this.activityEdit === 'Yes' &&
            this.activityDelete === 'Yes'
          ) ||
          (
            this.activityCanBrowse === 'No' &&
            this.activityNew === 'No' &&
            this.activityEdit === 'No' &&
            this.activityDelete === 'No'
          )
        )
      ) {
        this.activities = ''
      }

      if (
        this.activityCanBrowse === 'Yes' &&
        this.activityNew === 'Yes' &&
        this.activityEdit === 'Yes' &&
        this.activityDelete === 'Yes'
      ) {
        this.activities = 'Admin'
      } else if (
        this.activityCanBrowse === 'No' &&
        this.activityNew === 'No' &&
        this.activityEdit === 'No' &&
        this.activityDelete === 'No'
      ) {
        this.activities = 'None'
      }
    },
    checkQuotations() {
      if (
        !(
          (
            this.quotationCanBrowse === 'Yes' &&
            this.quotationNew === 'Yes' &&
            this.quotationEdit === 'Yes' &&
            this.quotationDelete === 'Yes'
          ) ||
          (
            this.quotationCanBrowse === 'No' &&
            this.quotationNew === 'No' &&
            this.quotationEdit === 'No' &&
            this.quotationDelete === 'No'
          )
        )
      ) {
        this.quotations = ''
      }

      if (
        this.quotationCanBrowse === 'Yes' &&
        this.quotationNew === 'Yes' &&
        this.quotationEdit === 'Yes' &&
        this.quotationDelete === 'Yes'
      ) {
        this.quotations = 'Admin'
      } else if (
        this.quotationCanBrowse === 'No' &&
        this.quotationNew === 'No' &&
        this.quotationEdit === 'No' &&
        this.quotationDelete === 'No'
      ) {
        this.quotations = 'None'
      }
    },
    checkSettings() {
      if ( // even though it has only 1 condition but still it checks for valid values
        !(
          (
            this.settingBranches === 'None'
          ) ||
          (
            this.settingBranches === 'View'
          ) ||
          (
            this.settingBranches === 'Edit'
          ) ||
          (
            this.settingBranches === 'New'
          )
        )
      ) {
        this.settings = ''
      }

      if (
        this.settingBranches === 'New'
      ) {
        this.settings = 'Admin'
      } else if (
        this.settingBranches === 'Edit'
      ) {
        this.settings = 'Editor'
      } else if (
        this.settingBranches === 'View'
      ) {
        this.settings = 'Viewer'
      } else if (
        this.settingBranches === 'None'
      ) {
        this.settings = 'None'
      }
    },
    checkReports() {
      if (
        !(
          (
            this.wonQuotations === 'Yes' &&
            this.lostQuotations === 'Yes'
          ) ||
          (
            this.wonQuotations === 'No' &&
            this.lostQuotations === 'No'
          )
        )
      ) {
        this.reports = ''
      }

      if (
        this.wonQuotations === 'Yes' &&
        this.lostQuotations === 'Yes'
      ) {
        this.reports = 'Admin'
      } else if (
        this.wonQuotations === 'No' &&
        this.lostQuotations === 'No'
      ) {
        this.reports = 'None'
      }
    },
    checkFunctions() {
      if (
        !(
          (
            this.canSetEnquiryToCancelled === 'Yes' &&
            this.canSetQuotationToCancelled === 'Yes'
          ) ||
          (
            this.canSetEnquiryToCancelled === 'No' &&
            this.canSetQuotationToCancelled === 'No'
          )
        )
      ) {
        this.functions = ''
      }

      if (
        this.canSetEnquiryToCancelled === 'Yes' &&
        this.canSetQuotationToCancelled === 'Yes'
      ) {
        this.functions = 'Admin'
      } else if (
        this.canSetEnquiryToCancelled === 'No' &&
        this.canSetQuotationToCancelled === 'No'
      ) {
        this.functions = 'None'
      }
    },
  }
}
</script>

<style>

.portionHeading {
  text-decoration: underline;
}

</style>